export const getUrgencyProgress = (horasTranscurridas, reglas) => {
  try {
    if (horasTranscurridas === null || horasTranscurridas === undefined) {
      return 0;
    }

    if (!reglas) {
      return 0;
    }

    const horas = horasTranscurridas;

    if (horas >= reglas.rojo.min) {
      return 100;
    }

    if (horas >= reglas.amarillo.min && horas < reglas.amarillo.max) {
      const rango = reglas.amarillo.max - reglas.amarillo.min;
      const posicion = horas - reglas.amarillo.min;
      const porcentaje = (posicion / rango) * 100;
      return Math.round(Math.max(0, Math.min(porcentaje, 100)));
    }

    if (horas >= reglas.verde.min && horas < reglas.verde.max) {
      const rango = reglas.verde.max - reglas.verde.min;
      const posicion = horas - reglas.verde.min;
      const porcentaje = (posicion / rango) * 100;
      return Math.round(Math.max(0, Math.min(porcentaje, 100)));
    }

    return 0;
  } catch (error) {
    console.error("Error en getUrgencyProgress:", error);
    return 0;
  }
};